import { render, staticRenderFns } from "./index.vue?vue&type=template&id=733c224f&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=733c224f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733c224f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('733c224f')) {
      api.createRecord('733c224f', component.options)
    } else {
      api.reload('733c224f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=733c224f&scoped=true", function () {
      api.rerender('733c224f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/referrals/index.vue"
export default component.exports